import React, { useState } from "react"
import { connect } from "react-redux"
import { motion } from "framer-motion"

const AccordionNested = ({ id, title, children }) => {
  const [expanded, setExpanded] = useState(0)
  const isOpen = id === expanded

  return (
    <div key={id} id={id} className="accordionNested">
      <motion.button
        initial={false}
        onClick={() => setExpanded(isOpen ? false : id)}
        aria-expanded={isOpen}
        id={id}
        className={`accordionNested--toggle${isOpen ? " is-open" : ""}`}
      >
        {children}
      </motion.button>
    </div>
  )
}

export default connect(state => ({}), null)(AccordionNested)
